import { Component } from '@angular/core';
import { PolicyService } from 'src/app/core/services/policy.service';
export interface PolicyPaymentDetailes {
  policyNo: string;
  referenceNumber: string;
  isError: boolean;
  errorMessage: string;
}
@Component({
  selector: 'app-policy-purchase-details',
  templateUrl: './policy-purchase-details.component.html',
  styleUrls: ['./policy-purchase-details.component.scss']
})
export class PolicyPurchaseDetailsComponent {
  policyPaymentDetailes: PolicyPaymentDetailes;
  constructor(
    private policyService: PolicyService
  ) {
    this.policyPaymentDetailes = this.policyService.getPolicyPaymentDetailes();
  };
}

